import { motion } from "framer-motion";

import { content } from "../../content/content";
import { leadership } from "../../data/team";
import { fadeUp, scaleIn, staggerContainer } from "../../hooks/useScrollReveal";
import { SeedConstellation } from "../Ornaments";

export function Team() {
  return (
    <section
      id="team"
      className="paper-grain relative overflow-hidden bg-warm-white py-28 md:py-40"
    >
      <SeedConstellation className="pointer-events-none absolute top-12 right-6 z-0 h-32 w-64 text-violet/40 md:top-16 md:right-12 md:h-44 md:w-80" />

      <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          className="mb-16 max-w-2xl"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <p
            data-edit-id="content.team.eyebrow"
            className="mb-4 font-body text-xs font-medium tracking-[0.22em] text-violet uppercase"
          >
            {content.team.eyebrow}
          </p>
          <h2
            data-edit-id="content.team.headline"
            className="text-balance font-display text-[clamp(2rem,4vw,3.5rem)] text-ink"
          >
            {content.team.headline}
          </h2>
          <p
            data-edit-id="content.team.intro"
            className="mt-4 font-body text-lg text-ink-muted"
          >
            {content.team.intro}
          </p>
        </motion.div>

        <motion.div
          className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {leadership.map((member) => (
            <motion.div
              key={member.id}
              data-edit-id={`data.leadership[${member.id}]`}
              className="group"
              variants={scaleIn}
            >
              <div className="relative mb-5 aspect-[3/4] overflow-hidden rounded-2xl">
                <img
                  data-edit-id={`data.leadership[${member.id}].avatar`}
                  src={member.avatar}
                  alt={member.name}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <h3
                data-edit-id={`data.leadership[${member.id}].name`}
                className="font-display text-lg text-ink"
              >
                {member.name}
              </h3>
              <p
                data-edit-id={`data.leadership[${member.id}].role`}
                className="mt-0.5 font-body text-xs font-medium tracking-widest text-saffron-dark uppercase"
              >
                {member.role}
              </p>
              <p
                data-edit-id={`data.leadership[${member.id}].description`}
                className="mt-3 font-body text-sm leading-relaxed text-ink-muted"
              >
                {member.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
